import { css } from "@emotion/css";

export const blurCss = css({
  filter: "blur(6px)",
});
